/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_StartInputs */

const en_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Date Start`)
};

const fr_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début de période personnalisée`)
};

const de_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniertes Startdatum`)
};

const it_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di inizio personalizzata`)
};

const ru_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательская дата начала`)
};

const es_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio personalizada`)
};

const zh_cn2_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义日期开始`)
};

const ja_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム日付開始`)
};

const hi_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कस्टम तिथि प्रारंभ`)
};

const pt_pt2_custom_date_start = /** @type {(inputs: Custom_Date_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de início personalizada`)
};

/**
* | output |
* | --- |
* | "Custom Date Start" |
*
* @param {Custom_Date_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_start = /** @type {((inputs?: Custom_Date_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_date_start(inputs)
	if (locale === "de") return de_custom_date_start(inputs)
	if (locale === "it") return it_custom_date_start(inputs)
	if (locale === "ru") return ru_custom_date_start(inputs)
	if (locale === "es") return es_custom_date_start(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_date_start(inputs)
	if (locale === "ja") return ja_custom_date_start(inputs)
	if (locale === "hi") return hi_custom_date_start(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_date_start(inputs)
	return en_custom_date_start(inputs)
});